import { PaginationType, UserLoginType } from "@/DTO";
import {
  eraseCookie,
  getLocalItems,
  setLocalItems
} from "@/redux-config/hooks";
import { FetchByRefreshToken } from "@/api/auth";

export function ConvertToPaginationType(data: any): PaginationType {
  const pagination: PaginationType = {
    currentPage: data?.current_page,
    perPage: data?.per_page,
    total: data?.total
  };
  return pagination;
}

export function ConvertDateFormat(dateString: string) {
  const dateParts = dateString.split("/");
  const ConvertedDate = dateParts.join("-");
  return ConvertedDate;
}

export const handleAuthError = () => {
  let user: UserLoginType;
  if (
    getLocalItems("user") &&
    JSON.parse(getLocalItems("user")) != null &&
    JSON.parse(getLocalItems("user")) != ""
  ) {
    user = JSON.parse(getLocalItems("user"));
    if (user.refreshToken && user.refreshToken?.length > 0) {
      FetchByRefreshToken(user)
        .then((data) => {
          setLocalItems(
            "user",
            JSON.stringify(data.data, (key, value) => {
              return value;
            })
          );
          window.location.reload();
        })
        .catch((err) => {
          eraseCookie("user");
          localStorage.clear();
          window.location.href = "/login";
        });
    } else {
      eraseCookie("user");
      localStorage.clear();
      window.location.href = "/login";
    }
  } else {
    eraseCookie("user");
    localStorage.clear();
    window.location.href = "/login";
  }
};

